'use client'

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'

export default function JoinLinkUrl({ form }) {
  return (
    <FormField
      control={form.control}
      name="joinLinkUrl"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <h5 className="mt-8 font-semibold text-neutral-blue-300">
              Paste Link
            </h5>
          </FormLabel>
          <FormControl>
            <Input
              {...field}
              placeholder="Place your link here"
              className="mb-3 px-6 py-4 text-p-3 font-light"
            ></Input>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
